export default __webpack_public_path__ + "static/media/modules_guides.58540f7c.png";